import { useState } from "react";

const useChangeYearAndMonth = () => {
  const [year, setYear] = useState<number>(new Date().getFullYear());
  const [month, setMonth] = useState<number>(new Date().getMonth());

  const handleChangeYearAndMonth = (effect: "default" | "increase" | "decrease", dateT?: Date) => {
    if (effect === "increase") {
      if (month === 11) {
        setYear(year + 1);
        setMonth(0);
      } else {
        setMonth(month + 1);
      }
    }

    if (effect === "decrease") {
      if (month === 0) {
        setYear(year - 1);
        setMonth(11);
      } else {
        setMonth(month - 1);
      }
    }

    if (effect === "default" && dateT) {
      setYear(dateT.getFullYear());
      setMonth(dateT.getMonth());
    }
  };

  const handleChangeYear = (effect: "default" | "increase" | "decrease", dateT?: Date) => {
    if (effect === "increase") {
      setYear(year + 1);
    }

    if (effect === "decrease") {
      setYear(year - 1);
    }

    if (effect === "default" && dateT) {
      setYear(dateT.getFullYear());
      setMonth(dateT.getMonth());
    }
  };

  return { year, month, handleChangeYear, handleChangeYearAndMonth };
};

export default useChangeYearAndMonth;
